import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { RootReducerState } from '..';
import { fetchRecords } from './club-requests.action';

@Injectable({ providedIn: 'root' })
export class ClubRequestsTableService {

    constructor(
        private store: Store<RootReducerState>,
    ) { }
 
    pagination = [];
    filters = {
                created_at: "",
                billing_account_id: "",
                club_code: "",
                union_id: "",
                name: ""
            };


    sidebarCount: number = 0;
    page: number = 1;
    lastPage: number;
    limit: number = 10;
    initialSortColumn = 'created_at';
    initialSortDirection = 'desc';
    sortColumn = this.initialSortColumn;
    sortDirection = this.initialSortDirection;
    hasFilter = false;
    associations = [];
    columns = [
                { prop: 'created_at', name: 'COMMON.created-date', sortable: true, hasFilter: true, filter: "date", widthSet: 180},
                { prop: 'name', name: 'CLUB_REQUESTS.club-name', sortable: true, hasFilter: true, filter: "input"},
                { prop: 'union_id', name: 'CLUB_REQUESTS.union-id', sortable: true, hasFilter: true, filter: "input"},
                { prop: 'club_code', name: 'CLUB_REQUESTS.organization-id', sortable: true, hasFilter: true, filter: "input"},
                { prop: 'billing_account_id', name: 'CLUB_REQUESTS.billing-account-id', sortable: true, hasFilter: true, filter: "input"},
                { prop: 'actions', name: 'COMMON.actions', sortable: false, hasFilter: false, filter: ""}
            ];

    loadRecords() {
        this.hasFilter = this.hasActiveFilters();
        this.store.dispatch(fetchRecords());
    }

    hasActiveFilters(){

        if(
            (Object.values(this.filters).some(value => value !== '' && value !== null)) ||
            (this.sortDirection !== this.initialSortDirection || this.sortColumn !== this.initialSortColumn)
        )
            return true;
        else
            return false;        
    }

    resetFilters(){
        this.filters = {
            created_at: "",
            billing_account_id: "",
            club_code: "",
            union_id: "",
            name: ""
        }

        this.sortDirection = this.initialSortDirection;
        this.sortColumn = this.initialSortColumn;

        this.loadRecords();
    }

}